// Single-column shell rendered for every authenticated route under
// /studio/:slug and /account. Navigation lives entirely in the top bar's
// BrandMenu dropdown — there is no left rail. A header slot (after the repo
// picker) lets the active route hoist controls into the top bar.

import { ReactElement } from "react";
import { Outlet, useParams } from "react-router-dom";
import { TopBar } from "./TopBar";
import { HeaderSlotProvider } from "./headerSlot";
import { SettingsModal } from "../settings/SettingsModal";

export function WorkspaceLayout(): ReactElement {
  const { slug } = useParams<{ slug?: string }>();
  return (
    <HeaderSlotProvider>
      <div className="flex h-screen flex-col bg-slate-950 text-slate-100">
        <TopBar activeSlug={slug ?? null} />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-[radial-gradient(60rem_40rem_at_70%_-10%,rgba(56,189,248,0.06),transparent)]">
          <Outlet />
        </main>
        <SettingsModal />
      </div>
    </HeaderSlotProvider>
  );
}
